import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { httpEventBus } from '../../api/httpEventBus'
import { useNotification } from '../../contexts/NotificationContext'

const ApiErrorHandler = () => {
    const navigate = useNavigate()
    const { addNotification } = useNotification()

    useEffect(() => {
        httpEventBus.setNavigator(navigate)
        httpEventBus.setNotifier(addNotification)
    }, [navigate, addNotification])

    return null
}

export default ApiErrorHandler
